import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

const MapsContext = createContext({ provider: 'leaflet', apiKey: '', isLoaded: false });

export function MapsProvider({ children }) {
  const [config, setConfig] = useState({ provider: 'leaflet', apiKey: '', isLoaded: false });

  useEffect(() => {
    console.log('[MapsContext] Fetching maps config from:', `${API}/config/maps`);
    axios.get(`${API}/config/maps`)
      .then(res => {
        const d = res.data;
        console.log('[MapsContext] Raw response:', d);
        const newConfig = {
          provider: d.enabled && d.provider === 'google' && d.api_key ? 'google' : 'leaflet',
          apiKey: d.api_key || '',
          isLoaded: true
        };
        console.log('[MapsContext] Setting config:', { provider: newConfig.provider, hasApiKey: !!newConfig.apiKey });
        setConfig(newConfig);
      })
      .catch((err) => {
        console.error('[MapsContext] Failed to fetch maps config:', err);
        setConfig({ provider: 'leaflet', apiKey: '', isLoaded: true });
      });
  }, []);

  return <MapsContext.Provider value={config}>{children}</MapsContext.Provider>;
}

export const useMapsConfig = () => useContext(MapsContext);
